import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import MaterialSelector from '../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { interiorA03ImageOptions } from './views/InteriorA03'

class Interior2 extends Component {
	constructor(props) {
		super(props);
		this.handleUpholsteryCabinChange = this.handleUpholsteryCabinChange.bind(this);
		this.handleVeneerChange = this.handleVeneerChange.bind(this);
		this.handleFittingsChange = this.handleFittingsChange.bind(this);
	}

	handleUpholsteryCabinChange(newValue) {
		let configuration = this.props.configuration;
		configuration.UpholsteryCabin = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}


	handleVeneerChange(newValue, bubble = true) {
		let configuration = this.props.configuration;
		configuration.Veneer = newValue;

		if (bubble) {

			let fittingId = newValue.value;

			if (newValue.value === 4) {

				fittingId = 2;
			}

			let fitting = this.props.FittingsOptions.find(x => x.value === fittingId);

			this.handleFittingsChange(fitting, false);

		}


		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}


	handleFittingsChange(newValue, bubble = true) {
		let configuration = this.props.configuration;
		configuration.Fittings = newValue;

		if (bubble) {

			let veneerId = newValue.value;

			if (newValue.value === 2) {

				veneerId = 4;
			}

			let veneer = this.props.VeneerOptions.find(x => x.value === veneerId);

			this.handleVeneerChange(veneer, false);

		}

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

    render() {
		let imageOptions = interiorA03ImageOptions;

        let image = (
                <ConfiguratorImage boat="Xpower" configuration={this.props.configuration} options={imageOptions} />
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{ position: 'relative' }}>

					<h1><Trans defaults='Interior surfaces' /></h1>

					<h2><Trans defaults='Veneer' /></h2>
					<MaterialSelector options={this.props.VeneerOptions} label={this.props.configuration.Veneer.label} value={this.props.configuration.Veneer} onChange={this.handleVeneerChange} />

					<h2><Trans defaults='Finish' /></h2>

					<MaterialSelector options={this.props.FittingsOptions} label={this.props.configuration.Fittings.label} value={this.props.configuration.Fittings} onChange={this.handleFittingsChange} />

					<h1><Trans defaults='Interior upholstery' /></h1>
					<h2><Trans defaults='Fabric' /></h2>
					<MaterialSelector options={this.props.UpholsteryCabinOptions} label={this.props.configuration.UpholsteryCabin.label} value={this.props.configuration.UpholsteryCabin} onChange={this.handleUpholsteryCabinChange} />


					
                    <Disclaimer />


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Interior2);


// WEBPACK FOOTER //
// ./src/Xpower/Interior2.js